import { TestimonialCard } from '../TestimonialCard/TestimonialCard';
import { useScrollAnimation } from '../../hooks/useScrollAnimation';

export function CustomersSection() {
  const { ref: headerRef, isVisible: headerVisible } = useScrollAnimation();
  const { ref: cardsRef, isVisible: cardsVisible } = useScrollAnimation();
  const testimonials = [
    {
      rating: 5,
      review:
        'CommerceMinder ile e-ticaret süreçlerimizi\ntamamen dijitalleştirdik. Stok takibinden\nmüşteri hizmetlerine kadar her şey çok kolay.',
      name: 'Ahmet Kaya',
      role: 'Genel Müdür, TeknoMart',
    },
    {
      rating: 4.5,
      review:
        'Platformu kullanmaya başladığımızdan beri\nsatışlarımız %40 arttı. Entegrasyonlar\ngerçekten hayat kurtarıcı.',
      name: 'Zeynep Demir',
      role: 'E-ticaret Müdürü, ModaVitrin',
    },
    {
      rating: 5,
      review:
        'Müşteri destek ekibi harika! 7/24 yanımızda\nolduklarını bilmek büyük güven veriyor.\nKesintisiz hizmet alıyoruz.',
      name: 'Mehmet Özkan',
      role: 'Kurucu, ElektroPlus',
    },
    {
      rating: 4.5,
      review:
        'Raporlama sistemi sayesinde işimizi\ndaha iyi analiz edebiliyoruz. Veri odaklı\nkararlar almak artık çok kolay.',
      name: 'Ayşe Yılmaz',
      role: 'Pazarlama Direktörü, EvDekor',
    },
    {
      rating: 5,
      review:
        'Kurulum süreci çok hızlı ve pratikti.\n2 gün içinde tüm sistemlerimizi entegre\nettik. Harika bir deneyim!',
      name: 'Can Erdoğan',
      role: 'IT Müdürü, GıdaMarket',
    },
    {
      rating: 4,
      review:
        'Özellikle mobil uyumluluğu çok başarılı.\nMüşterilerimiz her yerden rahat alışveriş\nyapabiliyor. Memnuniyetimiz tam.',
      name: 'Fatma Şen',
      role: 'İşletme Sahibi, BoutiqueCafe',
    },
  ];

  return (
    <>
      <style
        dangerouslySetInnerHTML={{
          __html: `
          @media (max-width: 768px) {
            .mobile-customers-section {
              padding-top: 40px !important;
              padding-bottom: 40px !important;
              flex-direction: column !important;
              gap: 32px !important;
            }
            .mobile-customers-container {
              padding-left: 20px !important;
              padding-right: 20px !important;
              padding-top: 0 !important;
              padding-bottom: 0 !important;
            }
            .mobile-customers-title {
              font-size: 24px !important;
              line-height: 28px !important;
            }
            .mobile-customers-subtitle {
              font-size: 14px !important;
              line-height: 20px !important;
            }
            .mobile-customers-header {
              flex-direction: column !important;
              gap: 0 !important;
              align-items: flex-start !important;
            }
            .mobile-customers-header-text {
              padding-right: 0 !important;
              width: 100% !important;
            }
            .mobile-customers-badge {
              font-size: 10px !important;
              line-height: 16px !important;
              padding: 8px 16px !important;
            }
            .mobile-customers-grid {
              grid-template-columns: 1fr !important;
              gap: 16px !important;
            }
            .mobile-customers-card {
              padding: 20px !important;
              height: auto !important;
              width: 100% !important;
            }
            .mobile-customers-name {
              font-size: 12px !important;
            }
            .mobile-customers-role {
              font-size: 10px !important;
            }
            .mobile-customers-company {
              font-size: 10px !important;
            }
            .mobile-customers-review {
              font-size: 12px !important;
              line-height: 18px !important;
            }
          }
          `,
        }}
      />
      <div className="w-full py-[40px] bg-slate-950 flex justify-center items-center mobile-customers-section">
        <div className="w-full max-w-[1200px] px-[60px] py-10 bg-slate-950 flex flex-col justify-start items-start gap-14 mobile-customers-container">
          <div
            ref={headerRef}
            className={`w-full flex flex-col gap-12 transition-all duration-700 ease-out ${
              headerVisible
                ? 'opacity-100 transform translate-y-0'
                : 'opacity-0 transform translate-y-8'
            }`}
          >
            <div className="w-full flex justify-start items-center gap-3">
              <div
                className="size-2.5 rounded-[3px]"
                style={{ background: '#76BCE8' }}
              />
              <div className="inline-flex flex-col justify-start items-start">
                <div
                  className="justify-center text-xs font-semibold font-['Inter'] uppercase tracking-widest"
                  style={{ color: 'rgba(255, 255, 255, 0.5)' }}
                >
                  Müşteri Yorumları
                </div>
              </div>
            </div>

            <div className="w-full flex justify-start items-start gap-10 mobile-customers-header">
              <div className="flex-1 inline-flex flex-col justify-start items-start gap-4">
                <div className="self-stretch flex flex-col justify-start items-start">
                  <div
                    className="self-stretch justify-center text-3xl font-bold font-['Inter'] leading-10 mobile-customers-title"
                    style={{ color: '#FAFAFA' }}
                  >
                    Müşterilerimiz
                    <br />
                    <span style={{ color: '#76BCE8' }}>Ne Diyor?</span>
                  </div>
                </div>
              </div>
              <div className="pr-12 inline-flex flex-col justify-start items-start mobile-customers-header-text">
                <div
                  className="justify-center text-base font-normal font-['Inter'] mobile-customers-subtitle"
                  style={{
                    color: 'rgba(255, 255, 255, 0.45)',
                    lineHeight: '28px',
                  }}
                >
                  Platformumuzu kullanan işletmelerden gerçek
                  <br />
                  hikayeler. Gerçek sonuçlar, gerçek başarılar —<br />
                  doğrudan mutlu müşterilerimizden.
                </div>
              </div>
            </div>
          </div>

          <div
            ref={cardsRef}
            className={`w-full transition-all duration-700 ease-out ${
              cardsVisible
                ? 'opacity-100 transform translate-y-0'
                : 'opacity-0 transform translate-y-8'
            }`}
          >
            <div className="w-full grid grid-cols-3 gap-8 mobile-customers-grid">
              {testimonials.map((testimonial, index) => (
                <TestimonialCard
                  key={index}
                  rating={testimonial.rating}
                  review={testimonial.review}
                  name={testimonial.name}
                  role={testimonial.role}
                />
              ))}
            </div>
          </div>
        </div>
      </div>
    </>
  );
}
